import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import MemberForm from '../components/MemberForm';
import { callCreateMember, type CreateMemberInput } from '../lib/admin';
import type { MemberContact } from '../lib/members';

const blankInitial: MemberContact = {
  firstName: '',
  lastName: '',
  address: '',
  postalCode: '',
  city: '',
  alternateAddress: null,
  phoneLandline: null,
  phoneMobile: null,
  spouse: null,
};

export default function NewMember() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  async function handleSave(values: MemberContact & { email: string; status: 'active' | 'former' }) {
    setError(null);
    try {
      const input: CreateMemberInput = {
        email: values.email,
        firstName: values.firstName,
        lastName: values.lastName,
        address: values.address,
        postalCode: values.postalCode,
        city: values.city,
        alternateAddress: values.alternateAddress,
        phoneLandline: values.phoneLandline,
        phoneMobile: values.phoneMobile,
        spouse: values.spouse,
        boatPlaceIds: [],
      };
      const result = await callCreateMember(input);
      navigate(`/admin/medlemmar/${result.uid}`);
    } catch (e) {
      const err = e as { code?: string; message?: string };
      if (err.code === 'functions/already-exists') {
        setError(err.message ?? 'En medlem med den emailen finns redan.');
      } else if (err.code === 'functions/permission-denied') {
        setError('Du har inte admin-behörighet.');
      } else {
        setError(err.message ?? 'Kunde inte skapa medlem.');
      }
    }
  }

  return (
    <div className="space-y-4">
      <Link to="/admin/medlemmar" className="text-sm underline">
        ← Tillbaka
      </Link>
      <h1 className="text-xl font-bold">Ny medlem</h1>
      {error && <p className="text-sm text-red-700">{error}</p>}
      <MemberForm
        initial={blankInitial}
        email=""
        status="active"
        mode="admin"
        onSave={handleSave}
      />
    </div>
  );
}
